import React from 'react';

const AnimatedBackground: React.FC = () => {
    return (
        <div className="animated-bg">
            {/* Floating duck emojis */}
            {Array.from({ length: 12 }).map((_, i) => (
                <div
                    key={`duck-${i}`}
                    className="floating-duck-emoji"
                    style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 20}s`,
                        animationDuration: `${15 + Math.random() * 20}s`,
                        fontSize: `${1 + Math.random() * 2}rem`,
                        opacity: 0.15 + Math.random() * 0.15,
                    }}
                >
                    {i % 3 === 0 ? '🦆' : i % 3 === 1 ? '🐤' : '🪶'}
                </div>
            ))}

            {/* Bubbles */}
            {Array.from({ length: 20 }).map((_, i) => (
                <div
                    key={`bubble-${i}`}
                    className="floating-bubble"
                    style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 15}s`,
                        animationDuration: `${10 + Math.random() * 15}s`,
                        width: `${4 + Math.random() * 12}px`,
                        height: `${4 + Math.random() * 12}px`,
                    }}
                />
            ))}

            {/* Glowing orbs */}
            <div className="bg-orb bg-orb-1" />
            <div className="bg-orb bg-orb-2" />
            <div className="bg-orb bg-orb-3" />
            <div className="bg-orb bg-orb-4" />

            {/* Grid pattern overlay */}
            <div className="bg-grid" />
        </div>
    );
};

export default AnimatedBackground;
